import Pqp from "../inc/Pqp";

export default class CommonBlocks {
  constructor() {

  }

  init() {
    this.init_hero();    
    this.init_nl();
  }

  init_hero() {
    const btn = document.querySelector(".js-btn-scrolldown");
    const parent = btn?.parentElement;
    
    parent?.addEventListener("click", (e) => {
      if (
        btn?.tagName === "A" 
        && !Pqp.isNullOrEmpty(btn?.getAttribute("href"))
      ) {
        window.location = btn.getAttribute("href");
        return;        
      }

      const y = btn.closest("header")?.offsetHeight;

      if (isNaN(y) || Pqp.isNullOrEmpty(y)) 
        return;

      const offset = y - window.scrollY;

      window.scrollBy({
        top: offset,
        left: 0,
        behavior: "smooth"
      });
    });        
  }

  init_nl() {
    const btn = document.querySelector(".js-btn-show-dialog-nl");
    btn.addEventListener("click", (e) => {
      const dialog = document.querySelector(".js-dialog-nl")?.cloneNode(true);            
      
      if (!dialog)
        return;

      const on_esc = (e) => {
        if (e.key === "Escape") {
          dialog.close();
        }
      }

      dialog.addEventListener("click", () => dialog.close());
      dialog.addEventListener("close", (e) => {
        dialog.remove();
        document.querySelector("html").classList.remove("no-overflow");
        document.querySelector("#page")?.removeAttribute("inert");
        window.removeEventListener("keydown", on_esc);
      });
      window.addEventListener("keydown", on_esc);

      const btn_close = dialog.querySelector(".js-btn-close");
      btn_close?.addEventListener("click", (e) => dialog.close());
      
      dialog.querySelector(".dialog-body")?.addEventListener("click", (e) => e.stopPropagation());

      document.body.appendChild(dialog);
      
      if (!dialog.open) {
        dialog.show();
        document.querySelector("html").classList.add("no-overflow");   
        document.querySelector("#page")?.setAttribute("inert", "");  
      }
    });    
  }
}